import { NOTE_MAX_LENGTH } from "Components/Analyses/constants";
import { CurrentContractListItemProposedStepActionType } from "Infrastructure/ApiZfp/Schema";
import type { ResourceDictionary } from "Infrastructure/Translations/ResourceDictionary";
import { Resources } from "Infrastructure/Translations/Resources";
import type { ObjPathProxy } from "ts-object-path";
import { type ObjectSchema, number, object, string } from "yup";
import { type AssetAllocationFields, createAssetAllocationSchema } from "../helpers";

export type SavingsFormType = AssetAllocationFields & {
  readonly investmentToolType: string;
  readonly institution?: string;
  readonly currentValue: number;
  readonly regularAmount: number;
  readonly horizon: number;
  readonly appreciationRate: number;
  readonly stateContribution?: number;
  readonly proposedStepAction: string;
  readonly proposedSolutionHorizon?: number;
  readonly newDeposit?: number;
  readonly newRegularDeposit?: number;
  readonly note?: string;
};

export const getSavingsFormSchema: (
  t: (resourcePath: ObjPathProxy<ResourceDictionary, string>, options?: any) => string,
  requireCharacteristics?: boolean,
) => ObjectSchema<SavingsFormType> = (t, requireCharacteristics) => {
  return object({
    investmentToolType: string().required(t(Resources.Validation.Required)),
    institution: string().optional(),
    currentValue: number().required(t(Resources.Validation.Required)),
    regularAmount: number().required(t(Resources.Validation.Required)),
    horizon: number().required(t(Resources.Validation.Required)),
    appreciationRate: number().required(t(Resources.Validation.Required)).max(100, t(Resources.Validation.PercentMax)),
    stateContribution: number().optional(),
    ...createAssetAllocationSchema(t, requireCharacteristics),
    proposedStepAction: string().required(t(Resources.Validation.Required)),
    newDeposit: number().test("conditional-required", t(Resources.Validation.Required), function (value) {
      const { proposedStepAction } = this.parent;
      if (proposedStepAction === CurrentContractListItemProposedStepActionType.Modify) {
        return value !== undefined && value !== null;
      }
      return true;
    }),
    newRegularDeposit: number().test("conditional-required", t(Resources.Validation.Required), function (value) {
      const { proposedStepAction } = this.parent;
      if (proposedStepAction === CurrentContractListItemProposedStepActionType.Modify) {
        return value !== undefined && value !== null;
      }
      return true;
    }),
    proposedSolutionHorizon: number().test("conditional-required", t(Resources.Validation.Required), function (value) {
      const { proposedStepAction } = this.parent;
      if (proposedStepAction === CurrentContractListItemProposedStepActionType.Modify) {
        return value !== undefined && value !== null;
      }
      return true;
    }),
    note: string().max(NOTE_MAX_LENGTH, t(Resources.Validation.String.Max, { count: NOTE_MAX_LENGTH })),
  }).defined();
};
